import {ChangeDetectionStrategy, Component, computed} from '@angular/core';
import {
  DashboardStudyViewerControllerService
} from '../../services/dashboard-study-viewer-controller/dashboard-study-viewer-controller.service';
import {DashboardStudyViewerLoadingStateLabels} from '../../symbols/dashboard-study-viewer.symbols';

@Component({
  selector: 'app-dashboard-study-viewer-loader',
  templateUrl: './dashboard-study-viewer-loader.component.html',
  styleUrls: ['./dashboard-study-viewer-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardStudyViewerLoaderComponent {
  /**
   * Computed property that returns the current loading state label.
   */
  public readonly loadingStateLabel = computed(
    () => DashboardStudyViewerLoadingStateLabels[this.studyViewerController.currentLoadingStatus()]
  );

  constructor(private studyViewerController: DashboardStudyViewerControllerService) {}
}
